module.exports = __webpack_public_path__ + "img/Daily_cleaning_service.6d293b7b.jpg";